import { Percent, Clock, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
const DiscountBanner = () => {
  return <section className="py-4 px-4 bg-gradient-to-r from-blue-primary via-green-primary to-blue-primary relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-r from-blue-primary/90 via-green-primary/90 to-blue-primary/90"></div>
      <div className="container mx-auto max-w-3xl relative z-10">
        <Card className="bg-white/95 backdrop-blur-sm border-0 shadow-lg">
          <CardContent className="p-4 md:p-6">
            <div className="text-center">
               <div className="flex items-center justify-center gap-2 mb-3">
                 <div className="p-1.5 bg-gradient-to-r from-blue-primary to-green-primary rounded-full">
                   <Percent className="text-white" size={20} />
                 </div>
                 <span className="text-2xl md:text-3xl font-bold bg-gradient-to-r from-blue-primary to-green-primary bg-clip-text text-transparent">
                   15% OFF
                 </span>
               </div>
               
               <h2 className="text-xl font-bold text-gray-800 mb-2 md:text-2xl">
                 Limited Time DNA Testing Discount
               </h2>
               
               <p className="text-base text-gray-600 mb-3 max-w-xl mx-auto">
                 Save 15% on all DNA relationship testing services. Professional, confidential, and court-admissible results with mobile collection service.
               </p>
               
               <div className="flex items-center justify-center gap-2 mb-4 text-blue-primary">
                 <Clock size={16} />
                 <span className="font-semibold text-sm">Offer expires soon - Book today!</span>
               </div>
              
              <div className="flex flex-col sm:flex-row gap-3 justify-center">
                <Button 
                  size="lg" 
                  className="bg-gradient-to-r from-blue-primary to-green-primary hover:from-blue-primary/90 hover:to-green-primary/90 text-white font-bold px-8 py-3 shadow-xl transform hover:scale-105 transition-all duration-300 group" 
                  onClick={() => window.location.href = '/booking'}
                  aria-label="Claim your 15% discount and schedule DNA test"
                >
                  Claim Your 15% Discount
                  <ArrowRight className="ml-2 group-hover:translate-x-1 transition-transform duration-200" size={18} />
                </Button>
                
                <Button 
                  size="lg" 
                  variant="outline" 
                  className="border-2 border-blue-primary text-blue-primary hover:bg-blue-light font-semibold px-6 py-3 transition-all duration-300" 
                  onClick={() => document.getElementById('services')?.scrollIntoView({
                    behavior: 'smooth'
                  })}
                  aria-label="View all DNA testing services"
                >
                  View All Services
                </Button>
              </div>
              
              <div className="mt-6 text-sm text-gray-500">
                <p className="font-medium text-gray-700 mb-2">Can't book online? Call us at 7135104442 or email info@nearlabservices.com</p>
                <p>* Discount applies to all DNA testing services. Cannot be combined with other offers.</p>
                <p>Valid for new appointments only. Mobile collection included.</p>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </section>;
};
export default DiscountBanner;